export default __webpack_public_path__ + "static/media/15 - Pomegranate Szn.2005d73d.jpg";